import {
  acquireEntraAccessToken,
  getStoredAuthProvider,
  isMsalConfigured,
} from '../../auth/msalService';

/**
 * Resolves the Bearer token for outbound API calls (legacy JWT or Entra access token).
 * @returns {Promise<string | null>}
 */
export async function getBearerTokenForApi() {
  const provider = getStoredAuthProvider();
  if (provider === 'entra' && isMsalConfigured()) {
    return (await acquireEntraAccessToken()) ?? null;
  }
  if (typeof window !== 'undefined') {
    return localStorage.getItem('accessToken');
  }
  return null;
}
